import { setContext } from '@apollo/client/link/context';
import * as Sentry from '@sentry/vue';
import { IS_DEVELOPMENT } from '@/lib/constants';
import { logger as globalLogger } from '@/logger';

const HEADER_NAME = 'X-Request-Id';
const logger = globalLogger.getLogger('apollo/sentry-request-id');

export const SentryRequestIdLink = setContext(
  (_operation, context: ApolloContext) => {
    const transactionId = crypto.randomUUID();

    Sentry.configureScope((scope) =>
      scope.setTag('transaction_id', transactionId),
    );

    if (IS_DEVELOPMENT) {
      logger.trace(`Set '${HEADER_NAME}' to '${transactionId}'`);
    }

    return {
      ...context,
      headers: {
        ...context.headers,
        [HEADER_NAME]: transactionId,
      },
    };
  },
);
